(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('PairFoodWinesInCellarDialogController', PairFoodWinesInCellarDialogController);

	PairFoodWinesInCellarDialogController.$inject = ['$mdDialog', 'food', 'distinction', 'wines', 'Utils'];

	function PairFoodWinesInCellarDialogController($mdDialog, food, distinction, wines, Utils){

		/* jshint validthis: true */
		var self = this;

		self.food = food;

		self.distinction = distinction;

		self.wines = wines;

		self.close = close;
		self.goToWine = goToWine;

		/** begin methods */

		function close(){
			$mdDialog.hide();
		}

		function goToWine(wine){

			close();

			Utils.go('wines/edit', {
				id: wine['_id']
			});
		}
	}

})();
